<form [formGroup]="form" (ngSubmit)="submit($event)">
	<zk-input [zkStatus]="getStatus('currentPassword')" class="zk-mb-6">
		<input
			zkInputRef
			formControlName="currentPassword"
			placeholder=" "
			type="password"
		/>
		<span zkInputLabel>{{
			'CHANGE_PASSWORD_FORM.CURRENT_PASSWORD' | translate
		}}</span>
		<span zkInputMessage>
			{{ getErrorMessage('currentPassword') }}
		</span>
	</zk-input>

	<zk-input [zkStatus]="getStatus('newPassword')" class="zk-mb-6">
		<input
			zkInputRef
			formControlName="newPassword"
			placeholder=" "
			type="password"
		/>
		<span zkInputLabel>{{
			'CHANGE_PASSWORD_FORM.NEW_PASSWORD' | translate
		}}</span>
		<span zkInputMessage>
			{{ getErrorMessage('newPassword') }}
		</span>
	</zk-input>

	<ul
		*ngIf="!getErrorMessage('newPassword')"
		class="zk--mt-6 zk-mb-6 zk-px-4 zk-text-left zk-list-disc zk-list-inside"
		[innerHTML]="'CHANGE_PASSWORD_FORM.INSTRUCTIONS' | translate"
	></ul>

	<zk-input [zkStatus]="getStatus('confirmNewPassword')">
		<input
			zkInputRef
			formControlName="confirmNewPassword"
			placeholder=" "
			type="password"
		/>
		<span zkInputLabel>{{
			'CHANGE_PASSWORD_FORM.CONFIRM_NEW_PASSWORD' | translate
		}}</span>
		<span zkInputMessage>
			{{ getErrorMessage('confirmNewPassword') }}
		</span>
	</zk-input>
</form>
